import { type FC, useState } from "react";
import { Stack, TextField } from "@mui/material";
import { useSnackbar } from "notistack";
import { ConfirmDialog } from "@/admin/shared/ui";
import { useCreateRefundMutation } from "@/admin/entities/refunds";

interface CreateRefundDialogProps {
  open: boolean;
  paymentId: string;
  onClose: () => void;
  onCompleted?: () => void;
}

export const CreateRefundDialog: FC<CreateRefundDialogProps> = ({
  open,
  paymentId,
  onClose,
  onCompleted,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const [amount, setAmount] = useState("");
  const [description, setDescription] = useState("");

  const [createRefund, { loading, error }] = useCreateRefundMutation({
    onCompleted: (data) => {
      if (data.createRefund.manual) {
        enqueueSnackbar(
          "Возврат учтён, доступ закрыт. Провайдер его не получил: деньги покупателю нужно вернуть вручную в его кабинете",
          { variant: "warning", autoHideDuration: 15000 }
        );
      } else {
        enqueueSnackbar("Запрос на возврат отправлен", { variant: "success" });
      }
      setAmount("");
      setDescription("");
      onClose();
      onCompleted?.();
    },
    onError: () => {
      // ошибка уже отображается через ErrorMessage внутри ConfirmDialog
    },
  });

  const handleConfirm = () => {
    if (!amount) return;

    void createRefund({
      variables: {
        input: {
          paymentId,
          amount: Number(amount),
          description: description || undefined,
        },
      },
    });
  };

  return (
    <ConfirmDialog
      open={open}
      onCancel={onClose}
      onConfirm={handleConfirm}
      confirmTitle="Оформить возврат"
      confirmText="Укажите сумму и, при необходимости, комментарий к возврату."
      loading={loading}
      error={error}
    >
      <Stack spacing={2}>
        <TextField
          label="Сумма"
          type="number"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          fullWidth
          autoFocus
        />
        <TextField
          label="Комментарий"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          fullWidth
          multiline
          minRows={2}
        />
      </Stack>
    </ConfirmDialog>
  );
};
